import { FlowSettingsField } from "./flowSchema";

// Values per the v2.1 entity doc (DiagnosticFlowNodes.QuestionType).
export const QuestionTypes = {
  FREE_TEXT: "TEXT",
  YES_NO: "YES_NO",
  TIME_DURATION: "DURATION",
  LIST: "LIST",
};

export const QuestionTypeLabelKeys = {
  [QuestionTypes.FREE_TEXT]: "DiagnosticFlowQuestionTypeFreeText",
  [QuestionTypes.YES_NO]: "DiagnosticFlowQuestionTypeYesNo",
  [QuestionTypes.TIME_DURATION]: "DiagnosticFlowQuestionTypeTimeDuration",
  [QuestionTypes.LIST]: "DiagnosticFlowQuestionTypeList",
};

export const DEFAULT_LIST_OPTIONS = ["", "", ""];

// Mirror DiagnosticFlowValidator.cs (MaxLabelLen / MaxPromptLen) so the client
// flags over-length fields before the backend rejects the save.
export const NODE_LABEL_MAX_LENGTH = 36;
export const NODE_PROMPT_MAX_LENGTH = 256;

// SAS entityType for flowchart images (per the media-files routing doc).
export const MEDIA_ENTITY_TYPE_DIAGNOSTIC_FLOWCHART = "diagnosticFlowChart";

// Mirrors the backend laborcodes validation: no leading/trailing/double ";".
export const LABOR_CODES_PATTERN = /^[^;]+(;[^;]+)*$/;

export const NodeTypes = {
  START: "startNode",
  QUESTION: "questionNode",
  TERMINAL: "terminalNode",
};

// Values per the v2.1 entity doc (DiagnosticFlowNodes.Section).
export const DiagnosticSections = Object.freeze({
  COMPLAINT: "COMPLAINT",
  DIAGNOSTICS: "DIAGNOSTICS",
  ORIGIN: "ORIGIN",
  REPAIR: "REPAIR",
  RESULT: "RESULT",
});

export const DiagnosticSectionLabelKeys = {
  [DiagnosticSections.COMPLAINT]: "DiagnosticFlowSectionComplaint",
  [DiagnosticSections.DIAGNOSTICS]: "DiagnosticFlowSectionDiagnostics",
  [DiagnosticSections.ORIGIN]: "DiagnosticFlowSectionOrigin",
  [DiagnosticSections.REPAIR]: "DiagnosticFlowSectionRepair",
  [DiagnosticSections.RESULT]: "DiagnosticFlowSectionResult",
};

export const getInitialFlowSettings = () => ({
  [FlowSettingsField.INFORMATION]: "",
  [FlowSettingsField.LABOR_CODES]: "",
  [FlowSettingsField.OUTLET_IDS]: [],
  [FlowSettingsField.BRAND_IDS]: [],
  [FlowSettingsField.IS_DEFAULT_FOR_WARRANTY]: false,
  [FlowSettingsField.IS_ACTIVE]: true,
  [FlowSettingsField.FLOWCHART_IMAGE]: null,
});
